import { Button, ButtonSize, Show } from "shared/components";
import {
  Calender,
  ChevronDown,
  ChevronUp,
  Database01
} from "untitledui-js-base";
import moment from "moment";
import { RentAmount } from "shared/components/RentAmount";
import { useAuthContext } from "providers/Auth";
import { Unit } from "types/landlord/address";
import { getSourceLabel } from "utils/getSourceLabel";

interface HeaderMobileDetailsProps {
  unit?: Unit;
  showDetails: boolean;
  onToggleDetails: (show: boolean) => void;
}

export const HeaderMobileDetails = ({
  unit,
  showDetails,
  onToggleDetails
}: HeaderMobileDetailsProps) => {
  const { type, pms } = useAuthContext();
  const homeSiteRentEnabled = pms.isManageAmerica || type.isHomeSiteRentEnabled;

  return (
    <div className="pl-3 py-2">
      <Show if={!showDetails}>
        <Button
          borderLess
          size={ButtonSize.SM}
          Icon={ChevronDown}
          onClick={() => onToggleDetails(true)}
        >
          Show details
        </Button>
      </Show>

      <Show if={showDetails}>
        <div className="flex flex-col gap-1.5 px-4 pt-4">
          <RentAmount
            value={
              type.isPMS
                ? unit?.pms_monthly_rent_amount
                : unit?.monthly_rent_amount
            }
            isMobile
            title={homeSiteRentEnabled ? "Total rent" : "Rent amount"}
          />
          <Show if={homeSiteRentEnabled}>
            <RentAmount
              value={unit?.home_rent_amount}
              title="Home rent"
              isMobile
            />
            <RentAmount
              value={unit?.site_rent_amount}
              title="Site rent"
              isMobile
            />
          </Show>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Database01 className="shrink-0 stroke-content-500" size="20" />
              <p className="font-medium text-sm text-content-500">Source</p>
            </div>
            <p className="font-medium text-sm text-content-500">
              {getSourceLabel(unit)}
            </p>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Calender className="shrink-0 stroke-content-500" size="20" />
              <p className="font-medium text-sm text-content-500">Available</p>
            </div>
            <p className="font-medium text-sm text-content-500">
              {unit?.available_at
                ? moment(unit.available_at).utc().format("MMM D, YYYY")
                : "--"}
            </p>
          </div>
        </div>
      </Show>

      <Show if={showDetails}>
        <Button
          borderLess
          size={ButtonSize.SM}
          Icon={ChevronUp}
          className="mt-2"
          onClick={() => onToggleDetails(false)}
        >
          Hide details
        </Button>
      </Show>
    </div>
  );
};
